module.exports = __webpack_public_path__ + "img/half-circle-white_v-18.05f81ae4.svg";